export default __webpack_public_path__ + "static/media/Logo.b8afd398.png";